import {ReservationWs} from "./reservation.ws";
import {ErrorWs} from "./error.ws";

export class ReservationResponseWs{
    reservation:ReservationWs;
    message:string;
    errors:ErrorWs[];
}